import fetch from '../utils/fetch'

// 主播相关
export function getAnchorList (query) {
  return fetch({
    url: '/live/anchor',
    method: 'get',
    params: query
  })
}
export function updateAnchorStatus (query) {
  return fetch({
    url: '/live/anchor/' + query.id + '/' + query.status,
    method: 'put',
    data: query
  })
}

export function updateRecordStatus (query) {
  return fetch({
    url: '/live/anchor/record/' + query.id + '/' + query.is_record,
    method: 'put',
    data: query
  })
}
export function getLiveLog (query)
{
  return fetch({
    url: '/live_log',
    method: 'get',
    params: query
  })
}
export function getMarkingLogExport (query)
{
  return fetch({
    url: '/markinglog/export',
    method: 'get',
    params: query
  })
}
export function getCountLogExport (query)
{
  return fetch({
    url: '/markinglog/countExport',
    method: 'get',
    params: query
  })
}
export function getLiveReceive (query)
{
  return fetch({
    url: '/live_receive',
    method: 'get',
    params: query
  })
}
// 用户视频营销操作记录
export function getLiveOperationLog (query)
{
  return fetch({
    url: '/live_operation_log',
    method: 'get',
    params: query
  })
}
export function updateAuthStatus (query) {
  return fetch({
    url: '/live/anchor/auth/' + query.id + '/' + query.is_auth,
    method: 'put',
    data: query
  })
}

export function deleteAnchor (itemId) {
  return fetch({
    url: '/live/anchor/' + itemId,
    method: 'delete'
  })
}

export function saveAnchor (query) {
  return fetch({
    url: '/live/anchor/',
    method: 'post',
    data: query
  })
}

export function getAnchorDetail (query) {
  return fetch({
    url: '/live/anchor/' + query.id,
    method: 'get',
    params: query
  })
}

export function getPushUrl (query) {
  return fetch({
    url: '/live/pushurl/',
    method: 'get',
    params: query
  })
}

//直播相关
export function getLiveList (query) {
  return fetch({
    url: '/live',
    method: 'get',
    params: query
  })
}
export function updateLiveStatus (query) {
  return fetch({
    url: '/live/' + query.id + '/' + query.is_record,
    method: 'put',
    data: query
  })
}
export function deleteLive (itemId) {
  return fetch({
    url: '/live/' + itemId,
    method: 'delete'
  })
}

export function BatchDeleteLive (query) {
  return fetch({
    url: '/live/batchdelete',
    method: 'post',
    data: query
  })
}

export function saveLive (query) {
  return fetch({
    url: '/live',
    method: 'post',
    data: query
  })
}
export function saveSortLive (query) {
  return fetch({
    url: '/live/sort',
    method: 'post',
    data: query
  })
}
export function saveShelfRule (query) {
  return fetch({
    url: '/live/shelf_rule',
    method: 'post',
    data: query
  })
}
export function getLiveDetail (query) {
  return fetch({
    url: '/live/' + query.id,
    method: 'get',
    params: query
  })
}

export function getLiveGoods (query) {
  return fetch({
    url: '/live/goods/' + query.id,
    method: 'get',
    params: query
  })
}

export function deleteLiveGoods (query) {
  return fetch({
    url: '/live/goods/' + query.live_id + '/' + query.goods_id,
    method: 'delete',
    params: query
  })
}

export function savePreNotice (query) {
  return fetch({
    url: '/live/prenotice',
    method: 'post',
    data: query
  })
}

export function uploadVideo (query) {
  return fetch({
    url: '/live/uploadVideo',
    method: 'post',
    data: query
  })
}

export function getShopItemsDetail (query) {
  return fetch({
    url: '/live/getshopitem/',
    method: 'get',
    params: query
  })
}
export function getShopItemsDetailAll (query) {
  return fetch({
    url: '/live/getitems/all/',
    method: 'get',
    params: query
  })
}

export function getLiveConf (query) {
  return fetch({
    url: '/live/conf/',
    method: 'get'
  })
}
/******直播分类相关**********/
export function saveCate (params) {
  return fetch({
    url: '/live/creatcates',
    method: 'post',
    data: params
  })
}
export function getCateList (query) {
  return fetch({
    url: '/live/cate',
    method: 'get',
    params: query
  })
}
export function updateCate (CateId, params) {
  return fetch({
    url: '/live/updateCates/'+CateId,
    method: 'put',
    data: params
  })
}
// 规则审核
export function VideoRulesStatus (live_id, params) {
  return fetch({
    url: '/live/video_rules_status/'+live_id,
    method: 'get',
    params: params
  })
}

export function deleteCate (CateId) {
  return fetch({
    url: '/live/deleteCate/' + CateId,
    method: 'delete'
  })
}
/******直播评论相关**********/

export function getCommentList (query) {
  return fetch({
    url: '/live/comment',
    method: 'get',
    params: query
  })
}
export function updateComment (Comment, params) {
  return fetch({
    url: '/live/updateComment/'+Comment,
    method: 'put',
    data: params
  })
}

export function deleteComment (Comment) {
  return fetch({
    url: '/live/deleteComment/' + Comment,
    method: 'delete'
  })
}

//导出报表
export function getLiveExport (query) {
    return fetch({
        url: '/live/getLiveExport',
        method: 'get',
        params: query
    })
}
//导出标题
export function getLiveExportTitle (query) {
    return fetch({
        url: '/live/getLiveExportTitle',
        method: 'get',
        params: query
    })
}
// 黑名单展示
export function getLiveBlack (query) {
    return fetch({
        url: '/live/live_black',
        method: 'get',
        params: query
    })
}



// WEBPACK FOOTER //
// ./src/api/live.js